<template>
  <div class="footer">
    <div class="content6">
      <router-link :to="{ name: 'Home' }" v-if="$route.path != '/profile'">
        <div class="content6-logo">
          <img
            height="43px"
            width="174px"
            src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
          />
        </div>
      </router-link>
      <div class="contact-content" v-if="$route.path != '/profile'">
        <img :src="facebookImgSrc" class="bottom-img" @click="gotoFacebook" />
        <el-popover placement="top" width="150" trigger="click">
          <div class="contact-img" style="text-align: center">
            <div>Scott Cao-ShopVidi</div>
            <img src="../../assets/erweima2x.png" />
            <div>whatsapp</div>
            <a
              href="javascript:void(0)"
              @click="
                gotoWhatsApp();
                return false;
              "
            >
              +852 60904204
            </a>
          </div>
          <div slot="reference">
            <img :src="phoneImgSrc" class="bottom-img" />
          </div>
        </el-popover>
        <a
          ><img :src="emailImgSrc" class="bottom-img" @click="gotoEmail()"
        /></a>
      </div>
      <div class="content6-about" v-if="$route.path != '/profile'">
        <router-link :to="{ name: 'about' }" class="content6-about-txt"
          >Our Story</router-link
        >
        <span class="content6-about-txt">|</span>
        <router-link :to="{ name: 'service' }" class="content6-about-txt"
          >Terms of Service</router-link
        >
        <span class="content6-about-txt">|</span>
        <router-link :to="{ name: 'privacy' }" class="content6-about-txt"
          >Privacy Policy</router-link
        >
        <span class="content6-about-txt">|</span>
        <router-link :to="{ name: 'contact' }" class="content6-about-txt"
          >Contact Us</router-link
        >
        <span class="content6-about-txt">|</span>
        <router-link :to="{ name: 'return' }" class="content6-about-txt"
          >Returns Policy</router-link
        >
      </div>
      <div class="content6-copy">
        <span style="color: #5d5d5d;">3427 Oakcliff Rd Ste 100, Atlanta, GA, 30340 USA</span>
        <span> Copyright © 2025 ShopVidi Inc.</span>
      </div>
    </div>

    <div class="float">
      <el-badge class="item" :value="values" v-if="login">
        <a href="javascript:void(0)" @click="gotoImportList()">
          <img src="../../assets/img/float1.png" />
        </a>
      </el-badge>
      <el-badge class="item" v-if="login">
        <a href="javascript:void(0)" @click="gotoMyOrder()"
          ><img src="../../assets/img/float2.png"
        /></a>
      </el-badge>
      <a href="javascript:void(0)" @click="gotoStore()"
        ><img src="../../assets/img/float3.png"
      /></a>
    </div>
  </div>
</template>

<script>
import { postAction, getAction } from '@/api/manage.js'
export default {
  name: 'Footer',
  props: ['value'],
  data() {
    return {
      feNetWork: '',
      facebookImgSrc: '',
      phoneImgSrc: '',
      emailImgSrc: '',
      values: this.value || localStorage.getItem('num'),
      listData: {
        sync_status: 0,
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  watch: {
    value(n, o) {
      console.log(n, o)
      this.values = n
    }
  },
  async created() {
    if (this.login) {
      let res = await getAction(
        '/store/tsStoreGoodsInfo/import/list',
        this.listData
      )
      this.values = res.result && res.result.total
      localStorage.setItem('num', res.result && res.result.total)
    }
    this.feNetWork = this.getEnvUrl()

    this.facebookImgSrc = require('../../assets/img/icon1.png')
    this.phoneImgSrc = require('../../assets/img/icon2.png')
    this.emailImgSrc = require('../../assets/img/icon3.png')
  },
  methods: {
    toHome() {
      if (this.$route.path == '/profile' || this.$route.path == '/profile') {

      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    /**
     * 去我的订单
     */
    gotoMyOrder() {
      this.$router.push({
        name: 'menu',
        params: {
          key: 'wholesale'
        }
      })
    },
    /**
     * 去我的导入列表
     */
    gotoImportList() {
      window.open(
        this.getEnvUrl() + this.$tokenUrl('/goods/import/list', true)
      )
    },
    /**
     * 去我的店铺
     */
    gotoStore() {
      window.open(
        process.env.SYSTEM_URL + this.$tokenUrl('/store/TsPersonalStoreList', true)
      )
    },
    cardClick(data) {
      this.$emit('clickHandle', data)
    },
    gotoHelpCenter() {
      window.open('https://intercom.help/ShopVidi/en/')
    },

    gotoEmail() {
      window.open('mailto:contact@shopvidi.com')
    },
    gotoWhatsApp() {
      window.open(
        'https://api.whatsapp.com/send/?phone=85260904204&text&app_absent=0'
      )
    },
    // 进入facebook
    gotoFacebook() {
      window.open('https://www.facebook.com/ShopVidiHome')
    },
    getEnvUrl() {
      let href = window.location.href
      let url = window.location.host
      if (href.indexOf('test') >= 0) {
        url = 'https://test-thalesmart-manage-ui.hupofintech.com'
        return url
      }
      if (href.indexOf('localhost') >= 0) {
        url = 'http://localhost:3000'
        return url
      }
      if (href.indexOf('shopvidi') >= 0) {
        url = 'https://p.shopvidi.com'
        return url
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.footer {
  .content6 {
    border-top: 1px solid #e1e1e1;
  }
  .content6-logo,
  .content6-about,
  .content6-copy {
    font-family: Graphik;
    margin: 0 auto;
    text-align: center;
  }
  .content6-logo {
    padding: 30px 0px 10px;
  }
  .content6-about {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    line-height: 30px;
    span {
      padding: 0 10px;
      color: #5d5d5d;
    }
    a {
      color: #5d5d5d;
    }
  }
  .content6-about-txt {
    font-size: 14px;
    font-weight: 500;

    text-decoration: none;
  }
  .content6-copy {
    font-family: Graphik;
    margin-top: 15px;
    font-size: 14px;
    font-weight: 500;
    line-height: 30px;
    color: #8f8f8f;
    padding: 0 0 36px;
    display: flex;
    flex-direction: column;
  }
  .contact-content {
    display: flex;
    width: 200px;
    margin: 30px auto;
    justify-content: space-around;
  }
  .bottom-img {
    cursor: pointer;
    height: 28px;
  }
  .float {
    display: none;
    position: fixed;
    right: 10px;
    bottom: 300px;
    width: 50px;
    z-index: 99;
    img {
      margin-bottom: 20px;
    }
    a {
      display: block;
      position: relative;
    }
    .upNum {
      position: absolute;
      top: -20px;
      right: 0;
      width: 100%;
      text-align: right;
      color: #FF4812;
      font-size: 16px;
      font-style: normal;
    }
    .an {
      animation: fadeOutUp 1s 1;
      -webkit-animation: fadeOutUp 1s 1;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }
  }
}
@-webkit-keyframes fadeOutUp {
  0% {
    opacity: 1;
  }

  to {
    -webkit-transform: translate3d(0, -100%, 0);
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}

@keyframes fadeOutUp {
  0% {
    opacity: 1;
  }

  to {
    -webkit-transform: translate3d(0, -100%, 0);
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}

@media screen and (max-width: 600px) {
  .footer {
    .float {
      bottom: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/footer.vue